<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app class="fill-height">
      <v-row class="m-0 fill-height">
        <v-col sm="3" md="2" xl="2" class="pt-1 fill-height">
          <v-row>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(-1)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col style="padding: 12px 0">
              <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDate"
                      label="Zeitraum"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    :type="currentMode === 'month' ? 'month' : 'date'"
                    scrollable
                    locale="de"
                    :key="currentMode"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setDate(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(1)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-select
              :items="dateModes"
              v-model="currentMode"
              filled
              hide-details
              label="Anzeige"
              class="mt-1"
          ></v-select>
          <v-list style="max-height: 80vh; overflow-y: auto">
                <v-list-item-group
                    v-model="currentMita"
                    color="primary"
                >
                  <v-list-item
                      v-for="(mita, i) in filteredItems"
                      :key="mita.id"
                      :value="mita.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="mita.name"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
        </v-col>
        <v-col sm="9" md="10" xl="10" class="fill-height">
          <auskunft-month v-if="currentMode === 'month'"
                          :date="selectedDate"
                          :current-mita="currentMita"
                          :current-mode="currentMode"
                          :mitas-flat="mitasFlat"
                          :show-loader="showLoader"
                          :hide-loader="hideLoader"
                          :holiday-lohn="holliday_lohn ? holliday_lohn.bis_id : ''"
          ></auskunft-month>
          <auskunft-week v-if="currentMode === 'week' || currentMode === '5week'"
                         :date="selectedDate"
                         :current-mita="currentMita"
                         :current-mode="currentMode"
                         :mitas-flat="mitasFlat"
                         :show-loader="showLoader"
                         :hide-loader="hideLoader"
                         :holiday-lohn="holliday_lohn ? holliday_lohn.bis_id : ''"
          > </auskunft-week>
          <auskunft-year v-if="currentMode === 'year'"
                         :date="selectedDate"
                         :current-mita="currentMita"
                         :current-mode="currentMode"
                         :mitas-flat="mitasFlat"
                         :show-loader="showLoader"
                         :hide-loader="hideLoader"
                         :holiday-lohn="holliday_lohn ? holliday_lohn.bis_id : ''"
                         @change-to-month="changeToMonth"
          > </auskunft-year>
          <!--v-overlay
              absolute
              :value="currentMita === undefined"
              style="margin: 12px"
              opacity="0.1"
          >
            <v-row>
              <v-col>
              </v-col>
            </v-row>
          </v-overlay-->
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"
import AuskunftMonth  from "@/views/calendar/AuskunftMonth.vue";
import AuskunftWeek  from "@/views/calendar/AuskunftWeek.vue";
import AuskunftYear  from "@/views/calendar/AuskunftYear.vue";

export default {
  name: "calendar",
  components: {
    AuskunftWeek,
    AuskunftMonth,
    AuskunftYear
  },
  data: () => ({
    dateModes: [{text: "5 Tage", value: "5week"}, {text: "Woche", value: "week"}, {text: "Monat", value: "month"}, {text: "Jahr", value: "year"}],
    currentMode: "5week",
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],

    overlay: true,
    currentMita: undefined,
    userDays: [],

    search: '',
    date: new Date().toISOString().substr(0, 10),
    selectedDate: new Date().toISOString().substr(0, 10),
    modal: false,
    holliday_lohn: null,
  }),
  computed: {
    formatedDate() {
      let splits = this.date.split("-");
      if (this.currentMode === 'month') {
        return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
      } else if (this.currentMode === 'year') {
        return splits[0]
      } else {
        let date = new Date(parseInt(splits[0]), parseInt(splits[1]) - 1, parseInt(splits[2]));
        let week = this.getWeekNumber(date);
        let year = date.getFullYear();
        return "KW " + week + ", " + year;
      }
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
  },
  mounted () {
    //this.$parent.$emit('close-side-bar');
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users'
    ).then(this.responseOkGet, this.responseError)
  },
  watch: {
    selectedDate() {
      this.saveQuery();
    },
    currentMode() {
      this.saveQuery();
    },
    currentMita() {
      this.saveQuery();
    }
  },
  methods: {
    changeToMonth(month) {
      let date = this.selectedDate.split("-")[0] + '-' + ('' + month).padStart(2, '0');
      this.currentMode = 'month';
      this.setDate(date);
    },
    saveQuery() {
      let query = {};
      if (this.currentMita !== undefined) {
        query.mita = this.currentMita;
      }
      query.date = this.selectedDate;
      query.mode = this.currentMode;
      try {
        this.$router.replace({query: query});
      } catch (e) {
        //ignore
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.mita !== undefined) {
        this.currentMita = query.mita;
      }
      if (query.date !== undefined) {
        this.selectedDate = query.date;
        this.date = query.date;
      }
      if (query.mode !== undefined) {
        this.currentMode = query.mode;
      }
    },
    moveDate(direction) {
      let curDate = new Date(this.selectedDate);
      let date;
      switch (this.currentMode) {
        case 'month':
          date = new Date(curDate.setMonth(curDate.getMonth() + direction)).toISOString().substring(0, 7);
          break
        case 'year':
          date = new Date(curDate.setFullYear(curDate.getFullYear() + direction)).toISOString().substring(0, 10);
          break
        default:
          date = new Date(curDate.setDate(curDate.getDate() + (direction * 7))).toISOString().substring(0, 10);
      }
      this.setDate(date);
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    clearSearch () {
      this.search="";
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.holliday_lohn = response.body.holliday_lohn;
        this.parseQuery();
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setDate(date) {
      if (this.currentMode === 'month') {
        date = date + "-01";
      }
      this.date = date;
      this.$refs.dialog.save(date);
      this.selectedDate = date;
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      // Return array of year and week number
      return weekNo;
    },
  }
}
</script>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #e4e5e6 !important;
}

::v-deep .v-list-item--link:before {
  background-color: transparent;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}


::v-deep .v-list-item {
  min-height: 36px!important;
  padding: 0 8px!important;
}

::v-deep .v-list-item__content {
  padding: 8px 0!important;
}

</style>
